<template>
	<div v-if="integration" class="formWrapper">
		<div style="position: absolute; right: 0px; top: 10px; z-index: 10;">
			<el-tooltip content="Help & Documentation" placement="bottom" effect="dark">
			<el-button
				@click="openHelp"
				plain
				type="primary"
				style="font-size: 15px"
				icon="el-icon-document"
				circle
			></el-button>
			</el-tooltip>
			<el-tooltip content="Integration Settings" placement="bottom" effect="dark">
			<el-button
				@click="showNodeSettingsModal = true"
				:disabled="readOnlyMode || workflow.isActive"
				plain
				type="primary"
				style="font-size: 15px"
				icon="el-icon-set-up"
				circle
			></el-button>
			</el-tooltip>
			<el-tooltip content="Close" placement="right" effect="dark">
			<el-button
				id="wf-tour-node-close-btn"
				@click="$emit('close')"
				type="primary"
				style="font-size: 15px"
				icon="el-icon-right"
				circle
			></el-button>
			</el-tooltip>
		</div>
		<div style="display: inline-flex; align-items: center; width: 100%; box-sizing: border-box; padding-right: 140px;">
			<div style="flex-shrink: 0;">
				<img
					v-if="integration.icon"
					style="width: 40px; margin-right: 10px"
					:src="
						`data:image/${integration.iconMimeType === 'png' ? 'png' : 'svg+xml'};base64, ` +
						integration.icon
					"
				/>
				<img
					style="width: 40px; margin-right: 10px"
					v-if="!integration.icon"
					class="nodeIcon"
					src="../assets/node.svg"
				/>
			</div>
			<div style="word-break: break-word;">
				<h3>{{ integration.nodeDescription.displayName }}</h3>
			</div>
		</div>
		<p style="margin-top: 0px">
			Configure this <b>{{ integration.nodeDescription.displayName }}</b> integration
		</p>
		<el-divider class="compressedDivider"></el-divider>
		<el-container>
			<el-main style="padding-left: 0px; padding-right: 0px; padding-top: 0px">
				<paramsInterfaceForm :readOnlyMode="readOnlyMode" :workflow="workflow" ref="paramsInterfaceForm" 
				@integration-test-started="(data) => $emit('integration-test-started', data)"
				@integration-test-event="(data) => $emit('integration-test-event', data)"
			/>
			</el-main>
		</el-container>
		<slideOutModal
			appendToBody
			@close="
				() => {
					showNodeSettingsModal = false;
				}
			"
			:visible="showNodeSettingsModal"
		>
			<integrationSettingsForm
				:key="integration.id"
				:workflow="workflow"
				:integration="integration"
				@operationComplete="showNodeSettingsModal = false"
			/>
		</slideOutModal>
	</div>
</template>

<script>
import paramsInterfaceForm from "./paramsInterfaceForm.vue";
import slideOutModal from "../components/slideOutModal.vue";
import integrationSettingsForm from "./integrationSettingsForm.vue";
export default {
	props: {
		workflow: Object,
		readOnlyMode: Boolean,
	},
	components: {
		paramsInterfaceForm,
		slideOutModal,
		integrationSettingsForm,
	},
	data() {
		return {
			integration: null,
			showNodeSettingsModal: false,
		};
	},
	mounted() {},
	methods: {
		openHelp() {
			const nodeName = this.integration?.nodeDescription?.nodesObjectPropertyName || this.integration?.name;
			if (nodeName) {
				window.open(`/docs/documentation?integration=${nodeName}`, '_blank');
			}
		},
		async saveParams(customSuccessMsg) {
			return await this.$refs.paramsInterfaceForm.save(customSuccessMsg);
		},
		loadFormData(integration, inputsOutputs) {
			this.integration = integration;
			this.$nextTick(() => {
				this.$refs.paramsInterfaceForm.loadFormData(integration, inputsOutputs);
			});
		},
	},
};
</script>

<style scoped>
.formWrapper {
	position: relative;
}

.compressedDivider {
	margin-bottom: 0px;
}
</style>
